import { render, staticRenderFns } from "./SemanticShiftVisualization.vue?vue&type=template&id=3da19daa"
import script from "./SemanticShiftVisualization.vue?vue&type=script&lang=js"
export * from "./SemanticShiftVisualization.vue?vue&type=script&lang=js"
import style0 from "./SemanticShiftVisualization.vue?vue&type=style&index=0&id=3da19daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports